import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ar from './locales/ar.json';

const applyDocumentDirection = (language) => {
    if (typeof document === 'undefined') return;
    const langCode = language?.toLowerCase().startsWith('ar') ? 'ar' : 'en';
    document.documentElement.dir = langCode === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = langCode;
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ar: { translation: ar }
        },
        fallbackLng: 'ar',
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['sessionStorage'],
            caches: ['sessionStorage']
        }
    });

i18n.on('languageChanged', applyDocumentDirection);

if (i18n.isInitialized) {
    applyDocumentDirection(i18n.resolvedLanguage || i18n.language);
} else {
    i18n.on('initialized', () => {
        applyDocumentDirection(i18n.resolvedLanguage || i18n.language);
    });
}

export default i18n;
